module.exports = __webpack_public_path__ + "static/img/KI.7fa1b14d.png";